import React from "react"
import { injectIntl, defineMessages } from "react-intl"
import { AppContext } from "@lightspeed-invoicing/core-client/frontend"
import moment from "moment"
import {Intl} from "../../state/helpers/IntlProps"

type Props = {
    intl: Intl
    date: string
}

const messages = defineMessages({
    today: {
        id: "dashboard.activity-feed.date-line.today",
        defaultMessage: "Today",
    }
})

const ActivityFeedDateLine = (props: Props) => {

    const locale = AppContext.getLocale().getLanguage()
    const today = moment().locale(locale).startOf("day")
    const activityDate = moment(props.date).locale(locale)
    let dateToDisplay = activityDate.format("LL").toString()

    if (today.diff(activityDate.startOf("day"), "days") == 0) {
        dateToDisplay = props.intl.formatMessage(messages.today)
    }

    return (
        <div className="d-flex flex-row align-items-center pl-3 pr-3" key={props.date}>
            
            <div className="short-line pl-0 pr-1">
                <hr className="date-line"/>
            </div>

            <div className="text-hr">
                <span className="text-hr__text">
                    {dateToDisplay}
                </span>
            </div>    

            <span className="flex-grow-1 pl-1 pr-0">
                <hr className="date-line"/>
            </span>

        </div>
    )
}

export default injectIntl(ActivityFeedDateLine)


// WEBPACK FOOTER //
// ./src/dashboard/activity-feed/ActivityFeedDateLine.tsx